export const supportType_Feedback = 'feedback';
export const supportType_Bug = 'bug';
const supportTypes = [supportType_Feedback, supportType_Bug];
//# sourceMappingURL=types.js.map